var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaves({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3806_12105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4.5C25.9036 4.5 31.5 10.0964 31.5 17C31.5 23.9036 25.9036 29.5 19 29.5C12.0964 29.5 6.5 23.9036 6.5 17C6.5 10.0964 12.0964 4.5 19 4.5Z",
    fill: "#491900",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6147 10.6141C18.656 9.57306 20.3442 9.57306 21.3855 10.6141L21.4194 10.6479C21.6479 10.8764 21.9581 11.0047 22.2813 11.0047C23.6907 11.0048 24.8331 12.1475 24.8334 13.5568V14.0282C24.8334 14.4763 25.0115 14.9065 25.3282 15.2235L25.8569 15.7521C26.4819 16.3772 26.8333 17.2256 26.8334 18.1096V21.0048C26.8334 22.1094 25.938 23.0048 24.8334 23.0048H22.1804C22.1759 23.0049 22.1713 23.0055 22.1667 23.0055H16.8334C16.8288 23.0055 16.8243 23.0049 16.8197 23.0048H14.1667C13.0622 23.0048 12.1667 22.1094 12.1667 21.0048V17.5399C12.1669 16.5663 12.6535 15.6568 13.4636 15.1167L13.4968 15.0946C13.9153 14.8155 14.1667 14.3456 14.1667 13.8426V13.5568C14.167 12.1475 15.3095 11.0048 16.7188 11.0047C17.042 11.0047 17.3522 10.8764 17.5808 10.6479L17.6147 10.6141ZM20.4428 11.5568C19.9222 11.0365 19.078 11.0365 18.5574 11.5568L18.5235 11.5906C18.0449 12.0692 17.3956 12.338 16.7188 12.338C16.0459 12.3382 15.5004 12.8839 15.5001 13.5568V13.8426C15.5001 14.7914 15.0258 15.6776 14.2364 16.204L14.2032 16.2261C13.764 16.5189 13.5002 17.0121 13.5001 17.5399V21.0048C13.5001 21.373 13.7986 21.6715 14.1667 21.6715H16.1667V19.6721C16.1668 19.0426 16.4633 18.4495 16.9669 18.0718L18.3002 17.0718C19.0112 16.5387 19.9889 16.5387 20.7 17.0718L22.0333 18.0718C22.5369 18.4495 22.8334 19.0426 22.8334 19.6721V21.6715H24.8334C25.2016 21.6715 25.5001 21.373 25.5001 21.0048V18.1096C25.5 17.5793 25.2891 17.0699 24.9141 16.6949L24.3855 16.1662C23.8187 15.5992 23.5001 14.8299 23.5001 14.0282V13.5568C23.4998 12.8839 22.9543 12.3382 22.2813 12.338C21.6045 12.338 20.9553 12.0692 20.4766 11.5906L20.4428 11.5568ZM19.8998 18.1389C19.6628 17.9613 19.3373 17.9613 19.1003 18.1389L17.767 19.1389C17.5992 19.2648 17.5001 19.4623 17.5001 19.6721V21.6715H21.5001V19.6721C21.5 19.4623 21.401 19.2648 21.2332 19.1389L19.8998 18.1389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3806_12105",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3806_12105"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3806_12105",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaves);
export default __webpack_public_path__ + "static/media/caves.9e490d478e677e711a2e701a571ed885.svg";
export { ForwardRef as ReactComponent };